import React, { createContext, useCallback, useContext, useState } from "react";
import { fetchConToken, fetchSinToken } from "../api/fetch";

export const AuthContext = createContext();

const initialState = {
  uid: null,

  checking: true,
  logged: false,
  nombre: null,
  roll: "",
  permisos: [],
};

export const AuthProvider = ({ children }) => {
  const [auth, setAuth] = useState(initialState);

  const login = async (user, password) => {
    const resp = await fetchSinToken("auth/login", { user, password }, "POST");

    if (resp.ok) {
      const { agente } = resp;
      localStorage.setItem("token", resp.token);
      localStorage.setItem("access", agente.permisos);
      localStorage.setItem("menu", agente.menu);

      setAuth({
        uid: agente.id,
        checking: false,
        logged: true,
        nombre: agente.name,
        roll: agente.rol,
        permisos: JSON.parse(agente.permisos),
      });
    }

    return resp.ok;
  };
  const tknAdmin = async (token) => {
    let authenticated = false;
    if (!token) {
      setAuth({
        uid: null,
        checking: false,
        logged: false,
        correo: null,
        roll: "",
        permisos: [],
      });

      return false;
    }
    const resp = await fetchConToken("auth/login", { token }, "POST");
    if (resp.ok) {
      const { agente } = resp;
      localStorage.setItem("token", resp.token);
      localStorage.setItem("access", agente.permisos);
      localStorage.setItem("menu", agente.menu);

      setAuth({
        uid: agente.id,
        checking: false,
        logged: true,
        nombre: agente.name,
        roll: agente.rol,
        permisos: JSON.parse(agente.permisos),
      });
      authenticated = true;
    } else {
      setAuth({
        uid: null,
        checking: false,
        logged: false,
        nombre: null,
        roll: "",
        permisos: [],
      });
    }

    return authenticated;
  };

  const verifyToken = useCallback(async () => {
    const token = localStorage.getItem("token");
    // Si token no existe
    if (!token) {
      setAuth({
        ...auth,
        uid: null,
        checking: false,
        logged: false,
        nombre: null,
        roll: "",
        permisos: [],
      });

      return false;
    }

    const resp = await fetchConToken("auth/renew");

    if (resp.ok) {
      localStorage.setItem("token", resp.token);
      const { agente } = resp;
      localStorage.setItem("access", agente.permisos);
      localStorage.setItem("menu", agente.menu);

      setAuth({
        ...auth,
        uid: agente.id,
        checking: false,
        logged: true,
        nombre: agente.name,
        roll: agente.rol,
        permisos: JSON.parse(agente.permisos),
      });

      return true;
    } else {
      setAuth({
        ...auth,
        uid: null,
        checking: false,
        logged: false,
        nombre: null,
        roll: "",
        permisos: [],
      });

      return false;
    }
  }, []);

  const logout = () => {
    localStorage.removeItem("token");
    localStorage.removeItem("menu");
    localStorage.removeItem("access");

    setAuth({
      uid: null,
      checking: false,
      logged: false,
      nombre: null,
      roll: "",
      permisos: [],
    });
  };

  return (
    <AuthContext.Provider
      value={{
        auth,
        login,
        verifyToken,
        logout,
        tknAdmin,
      }}
    >
      {children}
    </AuthContext.Provider>
  );
};
